import { render, staticRenderFns } from "./NoCarsCard.vue?vue&type=template&id=21450722&scoped=true"
import script from "./NoCarsCard.vue?vue&type=script&lang=js"
export * from "./NoCarsCard.vue?vue&type=script&lang=js"
import style0 from "./NoCarsCard.vue?vue&type=style&index=0&id=21450722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21450722",
  null
  
)

export default component.exports